export default "__VITE_ASSET__4bea8aab__"